import React, { useEffect, useRef, useState } from 'react'
import ConfigurationHeader from '../heading/ConfigurationHeader'
import * as yup from 'yup';
import { popupType } from '../../types/types'
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getNewConfiguration, overWriteConfig} from '../../services/uiConfigService'
import '../../features/authConfiguration/AuthConfiguration.css'
import { GenericPopUp } from '../popup/genericPopUp'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import ConfigComparePopup from '../popup/ConfigComparePopup'
import ImportConfig from '../importConfig/ImportConfig'
import BorderHeading from '../heading/BorderHeading'
import { GenericUIComponent } from './GenericUIComponent'
import * as Sentry from "@sentry/react";
import { openPopup } from '../../stateManagement/actions/popupActions';


export const configData2: any = {
  "authentication_configuration": {
      "configurations": [
        {
          "name": "otpDisclaimer",
          "type": "list",
          "value": [],
          "docUrl": "",
          "description": "",
          "defaultValue": [],
          "possibleVals": ["string"],
          "render":{}
        },
        {
          "name": "phoneNumberMaximumLength",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "PhoneNumberMaximumLength",
            "type": "textfield",
          }
        },
        {
          "name": "phoneNumberMinimumLength",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "PhoneNumberMinimumLength",
            "type": "textfield",
          }
        },
        {
          "name": "outletLoginHintText",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{}
        },
        {
          "name": "phoneLoginHintText",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{}
        },
        {
          "name": "logoutMessage",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "LogoutMessage",
            "type": "textfield",
          }
        },
        {
          "name": "otpTimer",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Otptype",
            "type": "textfield",
          }
        },
        {
          "name": "twoFactor",
          "type": "boolean",
          "value": false,
          "docUrl": "",
          "description": "Whether to enable two factor authentication or not",
          "defaultValue": false,
          "possibleVals": [],
          "render":{}
        },
        {
          "name": "loginType",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "login type",
          "defaultValue": "password",
          "possibleVals": ["password", "otp", "otpAndPassword"],
          "render":{
            "inputHeading": "Logintype",
            "type": "select",
            "extendedAttributes": {
                "lableId": "Select default order unit",
                "optionConfig": {
                    "options": [
                        {
                            "value": "password",
                            "title": "password"
                        },
                        {
                            "value": "otp",
                            "title": "otp"
                        },
                        {
                            "value": "otpAndPassword",
                            "title": "otpAndPassword"
                        }
                    ]
                }
            }
          }
        },
        {
          "name": "otpProvider",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "different req bodies are made for vonage and others while sending otp",
          "defaultValue": "",
          "possibleVals": ["vonage", "other"],
          "render":{
            "inputHeading": "Otpprovider",
            "type": "select",
            "extendedAttributes": {
                "lableId": "Select default order unit",
                "optionConfig": {
                    "options": [
                        {
                            "value": "vonage",
                            "title": "vonage"
                        },
                        {
                            "value": "gupshup",
                            "title": "gupshup"
                        }
                    ]
                }
            }
          }
        },
        {
          "name": "otpType",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "otp type",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Otptimer",
            "type": "textfield",
          }
        },
        {
          "name": "subheading",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Sub Heading To Be Displayed in App",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "Subheading",
            "type": "textfield",
          }
        },
        {
          "name": "instantRegistration",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Sub Heading To Be Displayed in App",
          "defaultValue": false,
          "possibleVals": [false, true],
          "render":{
            "inputHeading": "Instantregistration",
            "type": "checkbox",
            "extendedAttributes": {
            "label": "Yes"
            }
          }
        },
        {
          "name": "translation",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Sub Heading To Be Displayed in App",
          "defaultValue": false,
          "possibleVals": [false, true],
          "render":{
            "inputHeading": "Translation",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
        },
        {
          "name": "termsChecked",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Sub Heading To Be Displayed in App",
          "defaultValue": false,
          "possibleVals": [false, true],
          "render":{
            "inputHeading": "Termschecked",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
        },
        {
          "name": "deviceUID",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Sub Heading To Be Displayed in App",
          "defaultValue": false,
          "possibleVals": [false, true],
          "render":{
            "inputHeading": "Deviceuid",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
        },
        {
          "name": "loginBanners",
          "type": "list",
          "value": [],
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Login Banners to display in app",
          "defaultValue": [],
          "possibleVals": [],
          "render":{
            "inputHeading": "Upload the login banner",
            "type": "imageList",
            "extendedAttributes": {
            "label": "Upload Login Banner",
            "width": 720,
            "height": 540,
            "numberOfimg": 3
            }
          }
        }
      ],
      "domainType":"authentication_configuration",
      "heading": "Login Page Configuration",
      "import": true,
      "subSections": [
          {
              "sectionHeading": "",
              "inputFields": [
                  {
                    "name": "loginType",
                  },
                  {
                    "name": "otpProvider",
                  },
                  {
                    "name": "subheading"
                  },
                  {
                    "name": "phoneNumberMaximumLength"
                  },
                  {
                      "name": "phoneNumberMinimumLength"
                  },
                  {
                      "name": "logoutMessage"
                  },
                  {
                      "name": "otpType"
                  },
                  {
                      "name": "otpTimer"
                  },
                  {
                    "name": "deviceUID",
                  },
                  {
                    "name": "translation",
                  },
                  {
                    "name": "instantRegistration",
                  },
                  {
                    "name": "termsChecked",
                  },
                  {
                    "name": "loginBanners",
                  },
              ]
          }
      ]
  },
  "cart_configuration": {
      "configurations":[
        {
          "name": "orderFulfillmentTime",
          "type": "number",
          "value": 0,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "This specifies the number of days in which the order will be delivered.",
          "defaultValue": 0,
          "possibleVals": ["number"],
          "render":{
            "inputHeading": "Enter the number of days for delivery in order fulfillment time",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
        },
        {
          "name": "missedItemBasket",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show item basket in cart screen to validate all items are purchased from that basket or not.",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "In the basket titled: “items you may have missed”, which basket should be displayed?",
            "type": "select",
            "extendedAttributes":{
                "lableId":"missed basket",
                "optionConfig":{
                    "fetchOption":"true",
                    "fetchType": "config",
                    "source": "order_basket_configuration",
                    "configName": "orderBasketMapping",
                    "key": "id"
                }
            },
          }
        },
        {
          "name": "orderFulfillmentTimeMessage",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show some text message for order delivery instead of showing the delivery date.",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "What should be the text in place of order fullfillment time?",
            "type": "textfield",
          }
        },
        {
          "name": "fullFilledByLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Fullfilled By label",
          "defaultValue": "",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the label for fulfilled by?",
            "type": "textfield",
          }
        },
        {
          "name": "minOrder",
          "type": "integer",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "will min order visible in cart or not",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "Enter the min order value",
            "type": "textfield",
          }
        },
        {
          "name": "minOrderType",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "What will be the type of min order",
          "defaultValue": "",
          "possibleVals": ["value", "qty", "volume"],
          "render":{
            "inputHeading": "Min order condition should be?",
            "type": "select",
            "extendedAttributes":{
                "lableId":"Select min order type",
               "optionConfig":{
                "options":[
                    {
                        "value":"value",
                        "title":"value"
                    },
                    {
                        "value":"qty",
                        "title":"qty"
                    },
                    {
                        "value":"volume",
                        "title":"volume"
                    }
                ]
               }
            },
          }
        },
        {
          "name": "minOrderVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Display minimum order info.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Should the minimum order be visible?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "minOrderValidation",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Is min order validation required or not",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want to have minimum condition for placing order",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
          }
        },
        {
          "name": "showMissedSchemePopUp",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show missed scheme popup in cart screen",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "When the scheme is missed, do you want the user to be able to see a disclaimer that the scheme has been missed?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            },
          }
        },
        {
          "name": "isDeliveryDropdownVisible",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show expected delivery date options.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "isDeliveryDropdownVisible",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "deliveryDateApi",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To get delivery date options from the API.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "deliveryDateApi",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        }
      ],
      "domainType":"cart_configuration",
      "heading": "Cart Configuration",
      "import": true,
      "subSections": [
        {
          "sectionHeading": "CART PAGE",
          "inputFields": [
            {
              "name": "minOrderValidation",
            },
            {
              "name": "minOrderVisibility",
            },
            {
              "name": "minOrderType",
              "child": [
                {
                  "name": "minOrder"
                }
              ]
            },
          //   {
          //     "inputHeading": "Do you wish that the user be able to place orders in sets?",
          //     "type": "checkbox",
          //     "name": "buyInSets",
          //     "extendedAttributes":{
          //         "label": "Yes"
          //     }
          //   },
            {
              "name": "showMissedSchemePopUp",
              //  "child": [
              //   {
              //     "inputHeading": "After how much percentage of order",
              //     "type": "textfield",
              //     "name": "missedPoPUpMargin"
              //   }
              // ]
            },
          //   {
          //     "inputHeading": "Do you want the information regarding delivery date to be visible?",
          //     "type": "checkbox",
          //     "name": "estimatedDeliveryDateVisibility",
          //     "extendedAttributes":{
          //         "label": "Yes"
          //     }
          //   },
            {
              "name": "orderFulfillmentTime",
            },
            {
              "name": "orderFulfillmentTimeMessage"
            },
            {
              "name": "fullFilledByLabel"
            },
            {
              "name": "missedItemBasket",
            },
            {
              "name": "isDeliveryDropdownVisible",
            },
            {
              "name": "deliveryDateApi",
            },
          ]
        }
      ]
  },
  "checkout_configuration": {
      "configurations":[
        {
          "name": "orderTncVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show TnC in order summary page.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "OrderTncVisibility",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "orderTncLink",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Order TnC link",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "OrderTncLink",
            "type": "textfield",
          }
        },
        {
          "name": "estimatedDeliveryDateVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To display estimated delivery date in Cart Page.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want the information regarding delivery date to be visible?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "retailerMarginVisibility",
          "type": "boolean",
          "value": true,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show retailer margin in order summary page.",
          "defaultValue": true,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want the user to see the retailer margin?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "orderDSIdVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To input distributor id in order summary.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Can the user see the distributor id on checkout page?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "showFreeProductLabel",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show free product tag (image) in order summary page.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want that the free label to be displayed alongside the free product?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "showRedeemProductLabel",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show redeem product tag (image) in order summary page.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "showRedeemProductLabel",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "orderConfirmationPopup",
          "type": "boolean",
          "value": true,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show order confirmation popup while placing the order.",
          "defaultValue": true,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "orderConfirmationPopup",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "locationPopupOnOrder",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To capture the location while ordering.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "locationPopupOnOrder",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "orderSubmitButtonLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Label for order button in order checkout page.",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "orderSubmitButtonLabel",
            "type": "textfield",
          }
        },
        {
          "name": "orderCheckoutPtrLabel",
          "type": "string",
          "value": "PTR",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Label for PTR in order summary page.",
          "defaultValue": "PTR",
          "possibleVals": [],
          "render":{
            "inputHeading": "What should be the label for ptr on the checkout page?",
            "type": "textfield",
          }
        },
        {
          "name": "orderCheckoutFinalAmountLabel",
          "type": "string",
          "value": "FINAL AMOUNT",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Label for Final Amount in order summary page.",
          "defaultValue": "FINAL AMOUNT",
          "possibleVals": [],
          "render":{
            "inputHeading": "What should be the label of the final amount?",
            "type": "textfield",
          }
        },
        {
          "name": "orderCheckoutDefaultUnitLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Label for order unit in order summary page when there is no case and pack order.",
          "defaultValue": "",
          "possibleVals": [],
          "render":{
            "inputHeading": "orderCheckoutDefaultUnitLabel",
            "type": "textfield",
          }
        },
        {
          "name": "orderCheckoutUnitLabel",
          "type": "string",
          "value": "UNIT",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Label for order unit in order summary page.",
          "defaultValue": "UNIT",
          "possibleVals": [],
          "render":{
            "inputHeading": "What should be the label of the unit in order summary?",
            "type": "textfield",
          }
        },
        {
          "name": "orderCheckoutTotalAmountLabel",
          "type": "string",
          "value": "TOTAL AMOUNT",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Label for Total Amount in order summary page.",
          "defaultValue": "TOTAL AMOUNT",
          "possibleVals": [],
          "render":{
            "inputHeading": "What should be the label of the total amount?",
            "type": "textfield",
          }
        },
        {
          "name": "orderRemarksVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show order remarks input in order summary.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you wish to have any remarks for order?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "distributorVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show distributor details in order summary.",
          "defaultValue": false,
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want to show distributor visibility and details?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
        },
        {
          "name": "orderSummaryDisclaimer",
          "type": "list",
          "value": [],
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show disclaimers on order summary page.",
          "defaultValue": [],
          "possibleVals": ["string[]"],
          "render":{
            "inputHeading": "Do you wish to have disclaimers?",
            "type": "textfieldList",
          }
        }
      ],
      "domainType":"checkout_configuration",
      "heading": "Checkout Configuration",
      "import": true,
      "subSections": [
          {
              "sectionHeading": "CHECKOUT PAGE",
              "inputFields": [
                  {
                    "name": "estimatedDeliveryDateVisibility",
                    },
                    {
                      "name": "orderTncVisibility",
                    },
                    {
                      "name": "orderTncLink",
                    },
                  {
                    "name": "distributorVisibility",
                  },
                  {
                    "name": "orderDSIdVisibility",
                  },
                  {
                    "name": "retailerMarginVisibility",
                  },
                  {
                    "name": "showFreeProductLabel",
                  },
                  {
                    "name": "showRedeemProductLabel",
                  },
                  {
                    "name": "orderConfirmationPopup",
                  },
                  {
                    "name": "locationPopupOnOrder",
                  },
                  {
                    "name": "orderRemarksVisibility",
                  },
                  // {
                  //     "inputHeading": "Do you want display the total amount calculation?",
                  //     "type": "checkbox",
                  //     "name": "amountCalculation",
                  //     "extendedAttributes":{
                  //         "label": "Yes"
                  //     }
                  // },
                  // {
                  //     "inputHeading": "How should the scheme be calculated?",
                  //     "type": "select",
                  //     "name": "schemeCalculation",
                  //     "extendedAttributes":{
                  //         "lableId":"Select where to calculate scheme",
                  //         "optionConfig":{
                  //             "options":[
                  //                 {
                  //                     "value":"server",
                  //                     "title":"server"
                  //                 },
                  //                 {
                  //                     "value":"app",
                  //                     "title":"app"
                  //                 },
                  //                 {
                  //                     "value":"none",
                  //                     "title":"none"
                  //                 }
                  //             ]
                  //         }
                  //     },
                  // },
                  {
                    "name": "orderSummaryDisclaimer"
                  },
                  {
                      "name": "orderCheckoutPtrLabel"
                  },
                  {
                      "name": "orderCheckoutUnitLabel"
                  },
                  {
                      "name": "orderCheckoutFinalAmountLabel"
                  },
                  {
                      "name": "orderCheckoutDefaultUnitLabel"
                  },
                  {
                      "name": "orderCheckoutTotalAmountLabel"
                  },
                  {
                      "name": "orderSubmitButtonLabel"
                  },
              ]
          }
      ]
  },
  "catalogue_configuration": {
    "configurations": [
      {
          "name": "defaultQtyForOrder",
          "type": "number",
          "value": 5,
          "description": "maxAllowedDigitForOrder",
          "possibleVals": [1, 2, 3, 4],
          "render":{
            "inputHeading": "defaultQtyForOrder",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
      },
      {
          "name": "missedSchemeVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Tells what format should be used and corresponding handlebar helper runs. Helpers: CapitalizeText, upperCaseValue",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Should there be a pop up on missing schemes?",
                "type": "checkbox",
                "extendedAttributes":{
                  "label": "Yes"
              }
          }
      },
      {
          "name": "skuDescriptionFormatter",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Tells what format should be used and corresponding handlebar helper runs. Helpers: CapitalizeText, upperCaseValue",
          "possibleVals": ["captialize", "noFormatter", "uppercase", "lowercase"],
          "render":{
            "inputHeading": "What should be sku description format?",
            "type": "select",
            "extendedAttributes":{
                "lableId":"skuDescriptionFormatter",
                "optionConfig":{
                    "options":[
                        {
                            "value":"captialize",
                            "title":"captialize"
                        },
                        {
                            "value":"noFormatter",
                            "title":"noFormatter"
                        },
                        {
                            "value":"uppercase",
                            "title":"uppercase"
                        },
                        {
                            "value":"lowercase",
                            "title":"lowercase"
                        }
                    ]
                }
            },
          }
      },
      {
          "name": "mrpLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config in mrp span in ProductMrpTemplate or MultiUOM_ProductMrpTemplate template",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for mrp?",
            "type": "textfield",
          }
      },
      {
          "name": "schemeVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want schemes to be visible?",
            "type": "checkbox",
            "extendedAttributes":{
              "label": "Yes"
          }
          }
      },
      {
          "name": "casePtrLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for case ptr?",
            "type": "textfield",
          }
      },
      {
          "name": "packUnitLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for pack?",
            "type": "textfield",
          }
      },
      {
          "name": "otherUnitLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for other?",
            "type": "textfield",
          }
      },
      {
          "name": "ptrLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for ptr?",
            "type": "textfield",
          }
      },
      {
          "name": "packPtrLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for pack ptr?",
            "type": "textfield",
          }
      },
      {
          "name": "unitLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the exact label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for unit?",
            "type": "textfield",
          }
      },
      {
          "name": "suggestedQtyVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "it will show suggested qty in product card in catalogue",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you wish to display suggested quantity?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "orderSuggestedQty",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "it will be the value of suggested qty in product card in catalogue",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want that suggested quantity to be added to cart by default?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "multiUOMSelection",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To enable multiple uom selection so that a user is able to add a product in both case quantity as well as piece quantity",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Do you want to enable multi uom order?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "caseUnitLabel",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "renders the exact label that comes from the config",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "What should be the unit label for case?",
              "type": "textfield",
          }
      },
      {
          "name": "defaultCatalogueImage",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "It is the image to be shown when there is no image uploaded for the product or you can say placeholder image.",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Upload the image you wish to display when no image is available for the sku",
            "type": "image",
            "extendedAttributes":{
                "label": "Upload Image",
                "width":500,
                "height":500
            }
          }
      },
      {
          "name": "favouriteSKU",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Wrapper for the unlikedSKU and likedSKU component . Called from veritical card catalogue.This renders the liked (filled with red color/ or empty) heart component on the top right of the product card.",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "Can user have the option to save the sku in favourites?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "skuCodeCondition",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "render":{
            "inputHeading": "How many digits of sku should the user be able to see?",
            "type": "textfield",
          }
        },
        {
            "name": "skuCodeVisibility",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "Do you want sku code to be visible in description?",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              },
            }
        },
        {
            "name": "autoUomConversion",
            "type": "boolean",
            "value": true,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "It will convert uom automatically in order.",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "Do you want automatic UOM conversion?",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "maxAllowedDigitForOrder",
            "type": "number",
            "value": 3,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "maxAllowedDigitForOrder",
            "possibleVals": [],
            "render":{
              "inputHeading": "maxAllowedDigitForOrder",
              "type": "textfield",
              "extendedAttributes": {
                "textType": "number"
            }
            }
        },
        {
            "name": "additionalSchemes",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "This is the new offers template that gets rendered from either old or new sku tile . Renders at the bottom of the product card.",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "Do you wish to have additional schemes",
              "type": "checkbox",
              "extendedAttributes":{
                "label": "Yes"
            }
            }
        },
        {
            "name": "catalogueSortingConfig",
            "type": "list",
            "value": [],
            "docUrl": "",
            "description": "catalogue sorting config",
            "possibleVals": [
                {
                    "id": "packMrp",
                    "name": "MRP - Low to High",
                    "type": "ascending"
                },
                {
                    "id": "packMrp",
                    "name": "MRP - High to Low",
                    "type": "descending"
                },
                {
                    "id": "packPtr",
                    "name": "PTR - Low to High",
                    "type": "ascending"
                },
                {
                    "id": "packPtr",
                    "name": "PTR - High to Low",
                    "type": "descending"
                }
            ],
            "render":{
              "inputHeading": "Sorting options",
              "type":"multipleCheckbox",
              "extendedAttributes":{
                "key":"name",
                "checkboxOptions": [
                    {
                        "id": "packMrp",
                        "name": "MRP - Low to High",
                        "type": "ascending"
                    },
                    {
                        "id": "packMrp",
                        "name": "MRP - High to Low",
                        "type": "descending"
                    },
                    {
                        "id": "packPtr",
                        "name": "PTR - Low to High",
                        "type": "ascending"
                    },
                    {
                        "id": "packPtr",
                        "name": "PTR - High to Low",
                        "type": "descending"
                    }
                       
                ]
            }
            }
        },
        {
            "name": "ptrVisibility",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "whether to show price in catalogue card",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "ptrVisibility",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "pieceSizeVisibility",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "pieceSizeVisibility",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "pieceSizeLabel",
            "type": "string",
            "value": "",
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                "string"
            ],
            "render":{
              "inputHeading": "pieceSizeLabel",
              "type": "textfield",
            }
        },
        {
            "name": "caseToPieceVisibility",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "whether to show case to piece qty in catalogue card",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "caseToPieceVisibility",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "caseToPieceLabel",
            "type": "string",
            "value": "",
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                "string"
            ],
            "render":{
              "inputHeading": "caseToPieceLabel",
              "type": "textfield",
            }
        },
        {
            "name": "multiVariantOrder",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "multiVariantOrder",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "multiVariantHeader",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "multiVariantHeader",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "multiVariantSortingOption",
            "type": "string",
            "value": "pieceSize",
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "on what basis multivarient products will be sorted",
            "possibleVals": [
                "pieceSize",
                "buttonDescription",
                "manufacturingDate"
            ],
            "render":{
              "inputHeading": "What should be sku description format?",
                  "type": "select",
                  "extendedAttributes":{
                      "lableId":"multiVariantSortingOption",
                      "optionConfig":{
                          "options":[
                              {
                                  "value":"pieceSize",
                                  "title":"pieceSize"
                              },
                              {
                                  "value":"buttonDescription",
                                  "title":"buttonDescription"
                              },
                              {
                                  "value":"manufacturingDate",
                                  "title":"manufacturingDate"
                              }
                          ]
                      }
                  },
            }
        },
        {
            "name": "catalogueSortingType",
            "type": "string",
            "value": "",
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "To enable custom sorting type",
            "possibleVals": [
                "1",
                "2",
                "3"
            ],
            "render":{
              "inputHeading": "catalogueSortingType",
              "type": "select",
              "extendedAttributes":{
                  "lableId":"catalogueSortingType",
                  "optionConfig":{
                      "options":[
                          {
                              "value":"1",
                              "title":"1"
                          },
                          {
                              "value":"2",
                              "title":"2"
                          },
                          {
                              "value":"3",
                              "title":"3"
                          }
                      ]
                  }
              },
            }
        },
        {
            "name": "showScanButton",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "showScanButton",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "productTypeFilter",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "productTypeFilter",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "outletLevelPricing",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "outletLevelPricing",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "showStrikedOffPrice",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "showStrikedOffPrice",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "showMarginPercentage",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "showMarginPercentage",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "showPriceIncludeTax",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "showPriceIncludeTax",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "cataloguePrioritySorting",
            "type": "string",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                "desc",
                "asc"
            ],
            "render":{
              "inputHeading": "cataloguePrioritySorting",
              "type": "select",
              "extendedAttributes":{
                  "lableId":"cataloguePrioritySorting",
                  "optionConfig":{
                      "options":[
                          {
                              "value":"desc",
                              "title":"desc"
                          },
                          {
                              "value":"asc",
                              "title":"asc"
                          }
                      ]
                  }
              },
            }
        },
        {
            "name": "skuDescriptionCustomization",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "skuDescriptionCustomization",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "orderUomCheck",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "orderUomCheck",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "skuDescTranslation",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "skuDescTranslation",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "useInternationalPriceFormatter",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "useInternationalPriceFormatter",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "enableDynamicPricingWithoutSlabs",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "enableDynamicPricingWithoutSlabs",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "minPackPriceValidation",
            "type": "string",
            "value": "",
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                "string"
            ],
            "render":{
              "inputHeading": "minPackPriceValidation",
              "type": "textfield",
            }
        },
        {
            "name": "sspLabel",
            "type": "string",
            "value": "",
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                "string"
            ],
            "render":{
              "inputHeading": "sspLabel",
              "type": "textfield",
            }
        },
        {
            "name": "showSchemeOnImageTap",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "Wrapper for the unlikedSKU and likedSKU component . Called from veritical card catalogue.This renders the liked (filled with red color/ or empty) heart component on the top right of the product card.",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "showSchemeOnImageTap",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "displayProductValidationFilter",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "Wrapper for the unlikedSKU and likedSKU component . Called from veritical card catalogue.This renders the liked (filled with red color/ or empty) heart component on the top right of the product card.",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "displayProductValidationFilter",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "couponFilterVisibility",
            "type": "boolean",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "Wrapper for the unlikedSKU and likedSKU component . Called from veritical card catalogue.This renders the liked (filled with red color/ or empty) heart component on the top right of the product card.",
            "possibleVals": [
                true,
                false
            ],
            "render":{
              "inputHeading": "couponFilterVisibility",
              "type": "checkbox",
              "extendedAttributes":{
                  "label": "Yes"
              }
            }
        },
        {
            "name": "tabFilterType",
            "type": "string",
            "value": false,
            "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
            "description": "",
            "possibleVals": [
                "dropdown",
                "chip"
            ],
            "render":{
              "inputHeading": "tabFilterType",
              "type": "select",
              "extendedAttributes":{
                  "lableId":"tabFilterType",
                  "optionConfig":{
                      "options":[
                          {
                              "value":"dropdown",
                              "title":"dropdown"
                          },
                          {
                              "value":"chip",
                              "title":"chip"
                          }
                      ]
                  }
              },
            }
        }
    ],   
      "domainType":"catalogue_configuration",
      "heading": "Catalogue Configuration",
      "import": true,
      "subSections": [
        // {
        //   "sectionHeading": "TAB FILTERS CONFIGURATION",
        //   "inputFields": [
        //     {
        //       "inputHeading": "",
        //       "type": "relatedSelect",
        //       "name": "",
        //       "extendedAttributes":{
        //           "relatedElements":{
        //               "optionConfig":{
        //                   "options":[
        //                       { value: 'brand', title: "Brand" },
        //                       { value: 'category', title: "Category" },
        //                       { value: 'subCategory', title: "Sub category" },
        //                       { value: 'pieceSize', title: "Pack size" },
        //                       { value: 'none', title: "None" }
        //                   ]
        //               },
        //               "elements":[
        //                   {
        //                   "heading":"What should be the first filter for catalogue filtering?",
        //                   "elementId":"filter1"
        //                   },
        //                   {
        //                   "heading":"What should be the second filter for catalogue filtering?",
        //                   "elementId":"filter2"
        //                   },
        //                   {
        //                   "heading":"What should be the third filter for catalogue filtering?",
        //                   "elementId":"filter3"
        //                   },
        //               ]
        //           }
                 
        //       },
        //     }
        //   ]
        // },
        {
          "sectionHeading": "CATALOGUE VIEW CONFIGURATION",
          "inputFields": [
            {
              "name": "skuDescriptionFormatter",
            },
            {
              "name": "caseUnitLabel"
            },
            {
              "name": "ptrLabel"
            },
            {
              "name": "mrpLabel"
            },
            {
              "name": "casePtrLabel"
            },
            {
              "name": "unitLabel"
            },
            {
              "name": "packUnitLabel"
            },
            {
              "name": "otherUnitLabel"
            },
            {
              "name": "packPtrLabel"
            },
            {
              "name": "favouriteSKU",
            },
            {
              "name": "suggestedQtyVisibility",
            },
            {
              "name": "multiUOMSelection",
            },
            {
              "name": "skuCodeVisibility",
              "child": [
                {
                  "name": "skuCodeCondition"
                }
              ]
            },
            {
              "name": "orderSuggestedQty",
            },
            {
              "name": "autoUomConversion",
            },
            {
              "name": "ptrVisibility",
            },
            {
              "name": "pieceSizeVisibility",
            },
            {
              "name": "pieceSizeLabel"
            },
            {
              "name": "caseToPieceVisibility",
            },
            {
              "name": "caseToPieceLabel"
            },
            {
              "name": "multiVariantOrder",
            },
            {
              "name": "multiVariantHeader",
            },
            {
              "name": "showScanButton",
            },
            {
              "name": "outletLevelPricing",
            },
            {
              "name": "productTypeFilter",
            },
            {
              "name": "showStrikedOffPrice",
            },
            {
              "name": "showMarginPercentage",
            },
            {
              "name": "showPriceIncludeTax",
            },
            {
              "name": "skuDescriptionCustomization",
            },
            {
              "name": "maxAllowedDigitForOrder",
            },
            {
              "name": "orderUomCheck",
            },
            {
              "name": "skuDescTranslation",
            },
            {
              "name": "useInternationalPriceFormatter",
            },
            {
              "name": "enableDynamicPricingWithoutSlabs",
            },
            {
              "name": "minPackPriceValidation"
            },
            {
              "name": "sspLabel"
            },
            {
              "name": "showSchemeOnImageTap",
            },
            {
              "name": "displayProductValidationFilter",
            },
            {
              "name": "couponFilterVisibility",
            },
            {
              "name": "tabFilterType",
            },
            {
              "name": "defaultQtyForOrder",
            },
          ]
        },
        {
          "sectionHeading": "DUMMY PRODUCT UPLOAD",
          "inputFields":[
              {
                "name": "defaultCatalogueImage",
              }
          ]
        },
        {
          "sectionHeading": "SCHEME CONFIGURATION",
          "inputFields": [
              {
                "name": "schemeVisibility",
              },
              {
                "name": "additionalSchemes",
              },
              {
                "name": "missedSchemeVisibility",
              }
            ]
        },
        {
          "sectionHeading": "SORTING",
          "inputFields": [
              {
                "name": "catalogueSortingConfig",
              },
              {
                "name": "catalogueSortingType",
                },
                {
                  "name": "multiVariantSortingOption",
                },
                {
                  "name": "cataloguePrioritySorting",
                },
            ]
        }
      ]
  },
  "language_configuration":{
      "configurations": [
        {
          "name": "supportedLanguages",
          "type": "list",
          "value": [
            {
              "code": "en",
              "origin": "English",
              "language": "English"
            }
          ],
          "docUrl": "",
          "description": "language configuration",
          "possibleVals": [
            {
              "code": "en",
              "origin": "English",
              "language": "English"
            },
            {
              "code": "hi",
              "origin": "हिन्दी",
              "language": "Hindi"
            },
            {
              "code": "hie",
              "origin": "Hinglish",
              "language": "Hinglish"
            },
            {
              "code": "pa",
              "origin": "ਪੰਜਾਬੀ",
              "language": "Punjabi"
            },
            {
              "code": "ta",
              "origin": "தமிழ்",
              "language": "Tamil"
            },
            {
              "code": "te",
              "origin": "తెలుగు",
              "language": "Telugu"
            },
            {
              "code": "ml",
              "origin": "മലയാളം",
              "language": "Malayalam"
            },
            {
              "code": "kn",
              "origin": "ಕನ್ನಡ",
              "language": "Kannada"
            },
            {
              "code": "mr",
              "origin": "मराठी",
              "language": "Marathi"
            },
            {
              "code": "bn",
              "origin": "বাংলা",
              "language": "Bengali"
            },
            {
              "code": "as",
              "origin": "অসমীয়া",
              "language": "Assamese"
            },
            {
              "code": "gu",
              "origin": "ગુજરાતી",
              "language": "Gujarati"
            },
            {
              "code": "id",
              "origin": "Bahasa",
              "language": "Bahasa"
            },
            {
              "code": "zh",
              "origin": "中文",
              "language": "Mandarin"
            },
            {
              "code": "de",
              "origin": "German",
              "language": "German"
            },
            {
              "code": "es",
              "origin": "Spanish",
              "language": "Spanish"
            },
      
            {
              "code": "fr",
              "origin": "Française",
              "language": "French"
            },
            {
              "code": "it",
              "origin": "Italian",
              "language": "Italian"
            },
            {
              "code": "ja",
              "origin": "Japanese",
              "language": "Japanese"
            },
            {
              "code": "nl",
              "origin": "Dutch",
              "language": "Dutch"
            },
            {
              "code": "vi",
              "origin": "Vietnamese",
              "language": "Vietnamese"
            },
            {
              "code": "my",
              "origin": "မြန်မာ",
              "language": "Burmese"
            },
            {
              "code": "ne",
              "origin": "नेपाली",
              "language": "Nepali"
            },
            {
              "code": "km",
              "origin": "Khmer",
              "language": "Khmer"
            }
          ],
          "render":{
            "inputHeading": "",
            "type":"multipleCheckbox",
            "extendedAttributes":{
              "key":"language",
              "checkboxOptions": [
                {
                    "code": "en",
                    "origin": "English",
                    "language": "English"
                  },
                  {
                    "code": "hi",
                    "origin": "हिन्दी",
                    "language": "Hindi"
                  },
                  {
                    "code": "hie",
                    "origin": "Hinglish",
                    "language": "Hinglish"
                  },
                  {
                    "code": "pa",
                    "origin": "ਪੰਜਾਬੀ",
                    "language": "Punjabi"
                  },
                  {
                    "code": "ta",
                    "origin": "தமிழ்",
                    "language": "Tamil"
                  },
                  {
                    "code": "te",
                    "origin": "తెలుగు",
                    "language": "Telugu"
                  },
                  {
                    "code": "ml",
                    "origin": "മലയാളം",
                    "language": "Malayalam"
                  },
                  {
                    "code": "kn",
                    "origin": "ಕನ್ನಡ",
                    "language": "Kannada"
                  },
                  {
                    "code": "mr",
                    "origin": "मराठी",
                    "language": "Marathi"
                  },
                  {
                    "code": "bn",
                    "origin": "বাংলা",
                    "language": "Bengali"
                  },
                  {
                    "code": "as",
                    "origin": "অসমীয়া",
                    "language": "Assamese"
                  },
                  {
                    "code": "gu",
                    "origin": "ગુજરાતી",
                    "language": "Gujarati"
                  },
                  {
                    "code": "id",
                    "origin": "Bahasa",
                    "language": "Bahasa"
                  },
                  {
                    "code": "zh",
                    "origin": "中文",
                    "language": "Mandarin"
                  },
                  {
                    "code": "de",
                    "origin": "German",
                    "language": "German"
                  },
                  {
                    "code": "es",
                    "origin": "Spanish",
                    "language": "Spanish"
                  },
            
                  {
                    "code": "fr",
                    "origin": "Française",
                    "language": "French"
                  },
                  {
                    "code": "it",
                    "origin": "Italian",
                    "language": "Italian"
                  },
                  {
                    "code": "ja",
                    "origin": "Japanese",
                    "language": "Japanese"
                  },
                  {
                    "code": "nl",
                    "origin": "Dutch",
                    "language": "Dutch"
                  },
                  {
                    "code": "vi",
                    "origin": "Vietnamese",
                    "language": "Vietnamese"
                  },
                  {
                    "code": "my",
                    "origin": "မြန်မာ",
                    "language": "Burmese"
                  },
                  {
                    "code": "ne",
                    "origin": "नेपाली",
                    "language": "Nepali"
                  },
                  {
                    "code": "km",
                    "origin": "Khmer",
                    "language": "Khmer"
                  }
                     
              ]
          }
          }
        }
      ],
      "domainType":"multi_lingual_configuration",
      "heading": "Language Configuration",
      "import": true,
      "subSections": [
          {
              "sectionHeading": "SELECT THE LANGUAGE OPTIONS TO BE ENABLED",
              "inputFields": [
                  {
                    "name": "supportedLanguages",
                  },
              ]
          }
      ]
  },
  "order_configuration":{
    "configurations": [
      {
          "name": "defaultOrderUOM",
          "type": "string",
          "value": "null",
          "description": "",
          "defaultValue": true,
          "possibleVals": [
              "case",
              "piece",
              "null"
          ],
          "render":{
            "inputHeading": "What should be the default order UOM?",
            "type": "select",
            "extendedAttributes": {
                "lableId": "Select order calculation type",
                "optionConfig": {
                    "options": [
                        {
                            "value": "case",
                            "title": "case"
                        },
                        {
                            "value": "piece",
                            "title": "piece"
                        },
                        {
                            "value": "null",
                            "title": "null"
                        }
                    ]
                }
            }
          }
      },
      {
          "name": "orderCalculationType",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Calculation is based on the type of the config : 1) value : order will be calculated and placed on the basis of total amount of the order. For ex : in unnati (ITC client) the value will be equal to the total amount in MRP .2) volume : order will be calculated and placed on the basis of total quantity . For ex : in marsBelgium the volume of the order will the total pieces of the order.",
          "possibleVals": [
              "value",
              "volume",
              "value and volume"
          ],
          "render":{
            "inputHeading": "How should the order be calculated",
            "type": "select",
            "extendedAttributes": {
                "lableId": "Select order calculation type",
                "optionConfig": {
                    "options": [
                        {
                            "value": "value",
                            "title": "value"
                        },
                        {
                            "value": "volume",
                            "title": "volume"
                        },
                        {
                            "value": "value and volume",
                            "title": "value and volume"
                        }
                    ]
                }
            }
          }
      },
      {
          "name": "amountCalculation",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Whether to show amount in app or not.",
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "Do you want display the total amount calculation?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "taxVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "",
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "Do you want display the taxVisibility?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "orderCancellation",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Order cancellation option in the app",
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "Do you want  to enable order cancellation?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "orderCancellationPeriod",
          "type": "number",
          "value": 0,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Order cancellation option in the app will have this much time availability to cancel the order",
          "possibleVals": [
              1,
              2
          ],
          "render":{
            "inputHeading": "What should be the order cancellation time period (in minutes)?",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
      },
      {
          "name": "cancelOrderInOrdertracking",
          "type": "boolean",
          "value": false,
          "description": "",
          "defaultValue": false,
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "Do you want display the cancelOrderInOrdertracking?",
                      "type": "checkbox",
                      "extendedAttributes":{
                          "label": "Yes"
                      }
          }
      },
      {
          "name": "orderCancellationReasons",
          "type": "list",
          "value": [
              "I have ordered the products through Salesman.",
              "I ordered wrong product(s).",
              "I ordered wrong quantity.",
              "I got better rates elsewhere.",
              "Other reasons."
          ],
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
          "possibleVals": [],
          "render":{
            "inputHeading": "orderCancellationReasons",
            "type": "textfieldList",
          }
      },
      {
          "name": "orderCancellationDisclaimer",
          "type": "string",
          "value": "Before you cancel, please let us know the reason to help us improve our services",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
          "possibleVals": [],
          "render":{
            "inputHeading": "What text should the user see as a disclaimer before order cancellation?",
            "type": "textfield",
          }
      },
      {
          "name": "orderCancellationSummaryDisclaimer",
          "type": "string",
          "value": "Hi there! I have cancelled your order as per request.",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
          "possibleVals": [],
          "render":{
            "inputHeading": "What text should the user see after order cancellation?",
            "type": "textfield",
          }
      },
      {
          "name": "enableDynamicPrices",
          "type": "boolean",
          "value": false,
          "description": "enable banded pricing",
          "defaultValue": false,
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "enableDynamicPrices",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "stockVisibility",
          "type": "boolean",
          "value": false,
          "description": "",
          "defaultValue": false,
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "stockVisibility",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "showExternalRecommendations",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To make uom visible.",
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "Do you have external recommendations?",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "buyInSets",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To make uom visible.",
          "possibleVals": [
              true,
              false
          ],
          "render":{
            "inputHeading": "buyInSets",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      }
  ],        
      "domainType":"order_configuration",
      "heading": "Order Configuration",
      "import": true,
      "subSections": [
          {
              "sectionHeading": "Order Calculation",
              "inputFields": [
                  {
                    "name": "orderCalculationType",
                  },
                  {
                    "name": "defaultOrderUOM",
                  },
              ]
          },
          {
              "sectionHeading": "OTHER CONFIGURATIONS",
              "inputFields": [
                  {
                    "name": "showExternalRecommendations",
                  },
                  {
                    "name": "amountCalculation",
                  },
                  {
                    "name": "taxVisibility",
                  },
                  {
                    "name": "orderCancellation",
                  },
                  {
                    "name": "orderCancellationPeriod",
                  },
                  {
                    "name": "cancelOrderInOrdertracking",
                  },
                  {
                    "name": "orderCancellationReasons",
                  },
                  {
                    "name": "orderCancellationDisclaimer"
                  },
                  {
                    "name": "orderCancellationSummaryDisclaimer"
                  },
                  {
                    "name": "enableDynamicPrices",
                  },
                  {
                    "name": "stockVisibility",
                  },
                  {
                    "name": "buyInSets",
                  },
              ]
          }
      ]
  },
  "order_tracking_configuration":{
    "configurations": [
      {
          "name": "orderNotReceivedReasons",
          "type": "list",
          "value": [],
          "docUrl": "",
          "description": ".",
          "possibleVals": [],
          "render":{
            "inputHeading": "orderNotReceivedReasons",
            "type": "textfieldList",
          }
      },
      {
          "name": "orderTrackingStages",
          "type": "list",
          "value": [],
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "It will give lable and color mapping based on order source.",
          "possibleVals": [],
          "render":{
            "inputHeading": "What all stages do you want to display? **",
            "type": "trackOrder",
          }
      },
      {
          "name": "orderSourceMapping",
          "type": "list",
          "value": [],
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "It will give lable and color mapping based on order source.",
          "possibleVals": [],
          "render":{
            "inputHeading": "orderSourceMapping",
            "type": "track",
          }
      },
      {
          "name": "billingInformationVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "to show billing information in order tracking screen.",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "billingInformationVisibility",
            "type": "checkbox",
            "extendedAttributes":{
              "label": "Yes"
            }
          }
      },
      {
          "name": "orderTrackingInvoiceTabVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "to show order invoice tab in order tracking screen",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "orderTrackingInvoiceTabVisibility",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "editOrderTimeValidation",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Time range in which order can edit.",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "editOrderTimeValidation",
                      "type": "checkbox",
                      "extendedAttributes":{
                          "label": "Yes"
                      }
          }
      },
      {
          "name": "orderSourceVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Time range in which order can edit.",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "orderSourceVisibility",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "syncAllButtonVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Sync all button visibility in order tracking screen to sync order status.",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "syncAllButtonVisibility",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "normalisedQtyVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "It will enable normalised quantity in order tracking screen",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "normalisedQtyVisibility",
                      "type": "checkbox",
                      "extendedAttributes":{
                          "label": "Yes"
                      }
          }
      },
      {
          "name": "reOrder",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/wiki/spaces/AUD/pages/257327231",
          "description": "To show ReOrder feature in order tracking screen",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "reOrder",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "editOrder",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show EditOrder feature in order tracking screen",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "editOrder",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "showRejectOrder",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "To show EditOrder feature in order tracking screen",
          "possibleVals": [true, false],
          "render":{
            "inputHeading": "showRejectOrder",
            "type": "checkbox",
            "extendedAttributes":{
                "label": "Yes"
            }
          }
      },
      {
          "name": "orderTrackingDefaultRange",
          "type": "number",
          "value": 0,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "In orderTracking, fromDate is 2 months from today for retailer and for other designation it is today itself for normal orders by default. For saveOrder it is 15 days from today by default. Using this configuration we can set it n days from today where n is orderTrackingDefaultRange",
          "possibleVals": [1, "n"],
          "render":{
            "inputHeading": "orderTrackingDefaultRange",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
      }
  ],        
      "domainType":"order_tracking_configuration",
      "heading": "Order Tracking Configuration",
      "import": true,
      "subSections": [
          {
              "sectionHeading": "ORDER TRACKING CONFIG",
              "inputFields": [
                {
                  "name": "orderTrackingStages",
                },
                  {
                    "name": "orderSourceMapping",
                  },
                  {
                    "name": "billingInformationVisibility",
                  },
                  {
                    "name": "orderTrackingInvoiceTabVisibility",
                  },
                  {
                    "name": "editOrderTimeValidation",
                  },
                  {
                    "name": "orderSourceVisibility",
                  },
                  {
                    "name": "syncAllButtonVisibility",
                  },
                  {
                    "name": "normalisedQtyVisibility",
                  },
                  {
                    "name": "showRejectOrder",
                  },
                  {
                    "name": "orderTrackingDefaultRange",
                  },
                  {
                    "name": "orderNotReceivedReasons"
                },        
              ]
          },
          {
              "sectionHeading": "EDIT ORDER CONFIGURATION",
              "inputFields": [
                  {
                    "name": "reOrder",
                  },
                  {
                    "name": "editOrder",
                  },
              ]
          }
      ]
  },
  "app_configuration":{
    "configurations": [
      {
          "name": "clientLogo",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Client Logo",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Upload the logo you wish to display on the login screen",
            "type": "image",
            "extendedAttributes":{
                "label": "Upload Client Logo",
                "width":512,
                "height":512,
                "max":true                         
            }
          }
      },
      {
          "name": "clientHeaderLogo",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Client Header Logo",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Upload the logo you wish to display on the header",
            "type": "image",
            "extendedAttributes":{
                "label": "Upload Client Header",
                "width":512,
                "height":512,
                "max":true                             
            }
          }
      },
      {
          "name": "appIcon",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "App Icon",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Upload the app icon",
                      "type": "image",
                      "extendedAttributes":{
                          "label": "Upload App Icon",
                          "width":512,
                          "height":512,
                          "max":true                              
                      }
          }
      },
      {
          "name": "appName",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "App Name",
          "possibleVals": ["string"],
          "render":{ 
            "inputHeading": "What should be the name of the app?",
                      "type": "textfield", 
          }
      },
      {
          "name": "isAppOffline",
          "type": "string",
          "value": false,
          "docUrl": "",
          "description": "whether the app is OnLineApp or OfflineApp",
          "possibleVals": [true, false],
          "render":{  
            "inputHeading": "Do you wish the app to be functional offline?",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
      },
      {
          "name": "clientLogoHeight",
          "type": "number",
          "value": 80,
          "docUrl": "",
          "description": "Logo Height",
          "possibleVals": ["number"],
          "render":{  
            "inputHeading": "What should be the logo height ?",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
      },
      {
          "name": "clientHeaderLogoHeight",
          "type": "number",
          "value": 20,
          "docUrl": "",
          "description": "Logo Height",
          "possibleVals": ["number"],
          "render":{  
            "inputHeading": "What should be the header logo height ?",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
      },
      {
          "name": "moengageKey",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Moengage Key",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Moengage Key",
            "type": "textfield",
          }
      },
      {
          "name": "faqCount",
          "type": "number",
          "value": "",
          "docUrl": "",
          "description": "faq count",
          "possibleVals": ["number"],
          "render":{  
            "inputHeading": "FAQ Count",
                      "type": "textfield",
                      "extendedAttributes": {
                        "textType": "number"
                    }
          }
      },
      {
          "name": "shareText",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Share Text",
          "possibleVals": ["string"],
          "render":{ 
            "inputHeading": "app sharing message",
                      "type": "textfield", 
          }
      },
      {
          "name": "psLink",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "PS Link",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Play store link",
            "type": "textfield",
          }
      },
      {
          "name": "shareLogoImage",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Image used when sharing content from the application.",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "shareLogoImage",
                      "type": "image",
                      "extendedAttributes":{
                          "label": "Upload shareLogoImage",
                          "width":512,
                          "height":512,
                          "max":true                              
                      }
          }
      },
      {
          "name": "appBarColor",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "The background color of the application's app bar",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "appBarColor",
                      "type": "textfield",
          }
      },
      {
          "name": "loginBanner",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "login banner",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Upload the Login banner",
            "type": "image",
            "extendedAttributes":{
                "label": "Upload the Login banner",
                "width":720,
                "height":540,
                "max":true                            
            }
          }
      },
      {
          "name": "appPackageName",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "App Package Name",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Android App Package Name",
            "type": "textfield",
          }
      },
      {
          "name": "appbarBackgroundImage",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Appbar background image",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Upload appbar image",
            "type": "image",
            "extendedAttributes":{
                "label": "Upload Appbar Image",
                "width":512,
                "height":512,
                "parentName":"image",
                "max":true                              
            },
          }
      },
      {
          "name": "appBarBackgroundType",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "used to change the appbar background type",
          "possibleVals": ["solid", "gradient", "image"],
          "render":{ 
            "inputHeading": "Select header background type",
            "type": "select",
            "extendedAttributes": {
                "lableId": "",
                "optionConfig": {
                    "options": [
                        {
                            "value": "solid",
                            "title": "solid"
                        },
                        {
                            "value": "gradient",
                            "title": "gradient"
                        },
                        {
                            "value": "image",
                            "title": "image"
                        }
                    ]
                }
            }, 
          }
      },
      {
          "name": "solidAppBarColor",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Appbar background image",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Enter the hexcode of the Background Color",
            "type": "textfield",
            "extendedAttributes":{
                "parentName":"solid"                                               
            },
          }
      },
      {
          "name": "gradientAppBarColor",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Appbar background image",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Enter the hexcode of the Background Gradient Color",
                              "type": "colorInput",
                              "extendedAttributes":{
                                  "parentName":"gradient"
                              },
          }
      },
      {
          "name": "privacyPolicyValidation",
          "type": "string",
          "value": false,
          "docUrl": "",
          "description": "Privacy Policy Validation",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "privacyPolicyValidation",
            "type": "textfield",
          }
      },
      {
          "name": "loadingScreenText",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Loading Screen Text",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Enter the text that you wish to display on the loading screen",
            "type": "textfield",
          }
      },
      {
          "name": "loaderGIF",
          "type": "boolean",
          "value": false,
          "docUrl": "",
          "description": "Loader GIF",
          "possibleVals": [true, false],
          "render":{  
            "inputHeading": "loaderGIF",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
      },
      {
          "name": "loadingBackgroundImage",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Loading page background image",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "Upload the launch screen background image",
            "type": "image",
            "extendedAttributes":{
                "label": "Upload Launch screen Background Image",
                "width":1800,
                "height":1000,
                "max":true                              
            }
          }
      },
      {
          "name": "isSuggestProductToBeShown",
          "type": "boolean",
          "value": false,
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Boolean flag indicating whether product suggestions should be shown.",
          "possibleVals": [true, false],
          "render":{  
            "inputHeading": "isSuggestProductToBeShown",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
      },
      {
          "name": "slackAlertChannel",
          "type": "boolean",
          "value": false,
          "docUrl": "",
          "description": "Channel or destination for sending alerts via Slack",
          "possibleVals": [true, false],
          "render":{  
            "inputHeading": "slackAlertChannel",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
      },
      {
          "name": "validateCustomerType",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Configuration related to validating the type of customer.",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "validateCustomerType",
            "type": "textfield",
          }
      },
      {
          "name": "shipmentOptionsVisibility",
          "type": "boolean",
          "value": false,
          "docUrl": "",
          "description": "Configuration related to the visibility of shipment options.",
          "possibleVals": [true, false],
          "render":{  
            "inputHeading": "shipmentOptionsVisibility",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Yes"
            }
          }
      },
      {
          "name": "storeInRange",
          "type": "number",
          "value": 0,
          "docUrl": "",
          "description": " Outlet Range",
          "possibleVals": [] ,
          "render":{  
            "inputHeading": "storeInRange",
            "type": "textfield",
          }
      },
      {
          "name": "enableDistanceBasedOutletSorting",
          "type": "list",
          "value": [],
          "docUrl": "",
          "description": "Configuration to enable sorting of outlets based on distance.",
          "possibleVals": ["string"],
          "render":{  
            "inputHeading": "enableDistanceBasedOutletSorting",
            "type": "textfieldList",
          }
      },
      {
          "name": "outOfRangePopUpVisible",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "Configuration",
          "possibleVals": [
            "string"
        ],
        "render":{  
          "inputHeading": "outOfRangePopUpVisible",
          "type": "textfield",
        }
    },
    {
        "name": "locationPopup",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration related to location pop-ups.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "locationPopup",
          "type": "textfield",
        }
    },
    {
        "name": "loadingScreenTextList",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "List of texts displayed on the loading screen.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "loadingScreenTextList",
          "type": "textfield",
        }
    },
    {
        "name": "ondcWebviewServiceUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for an ONDC (Open Network for Digital Commerce) web view service.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "ondcWebviewServiceUrl",
          "type": "textfield",
        } 
    },
    {
        "name": "ondcLoaderImage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Image used as a loader for ONDC.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "ondcLoaderImage",
          "type": "textfield",
        }
    },
    {
        "name": "ondcLoaderGif",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "GIF image used as a loader for ONDC.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "ondcLoaderGif",
          "type": "textfield",
        }
    },
    {
        "name": "ondcWebviewLaunchUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for launching an ONDC web view.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "ondcWebviewLaunchUrl",
          "type": "textfield",
        }
    },
    {
        "name": "ondcWebLaunchUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for launching an ONDC web view.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "ondcWebLaunchUrl",
          "type": "textfield",
        }
    },
    {
        "name": "kibanaConfig",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration related to Kibana, possibly for logging or monitoring.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "kibanaConfig",
          "type": "textfield",
        }
    },
    {
        "name": "encryptImage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration related to image encryption.",
        "possibleVals": [
            "string"
        ],
        "render":{  
          "inputHeading": "encryptImage",
          "type": "textfield",
        }  
    },
    {
        "name": "showPromoTransaction",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration related to displaying promotional transactions.",
        "possibleVals": [
            "string"
        ],
        "render":{                        
        "inputHeading": "showPromoTransaction",
        "type": "textfield",
        }  
    },
    {
        "name": "minimizePromoRedemptionJourney",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration to minimize the promotional redemption journey.",
        "possibleVals": [
            "string"
        ],
        "render":{  
          "inputHeading": "minimizePromoRedemptionJourney",
          "type": "textfield",
        }  
    },
    {
        "name": "addPromoOtpValidation",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration to add OTP validation for promotions.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "addPromoOtpValidation",
          "type": "textfield",
        } 
    },
    {
        "name": "externalAppDeepLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Deep link to an external application.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "externalAppDeepLink",
          "type": "textfield",
        } 
    },
    {
        "name": "deepLinkUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for deep linking within the application.",
        "possibleVals": [
            "string"
        ]  ,
        "render":{  
          "inputHeading": "deepLinkUrl",
          "type": "textfield",
        }
    },
    {
        "name": "appStoreLink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Link to the application on the app store.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "appStoreLink",
          "type": "textfield",
        } 
    },
    {
        "name": "consumerPromoOutletsFileUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for a file containing promotional outlets for consumers.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "consumerPromoOutletsFileUrl",
          "type": "textfield",
        } 
    },
    {
        "name": "tvAdsHeading",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Heading for TV advertisements.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "tvAdsHeading",
          "type": "textfield",
        } 
    },
    {
        "name": "tvAdsSubheading",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Subheading for TV advertisements.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "tvAdsSubheading",
          "type": "textfield",
        } 
    },
    {
        "name": "remoteOrderlinkMessage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Message related to remote order links.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "remoteOrderlinkMessage",
          "type": "textfield",
        } 
    },
    {
        "name": "remoteOrderlink",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Remote order link.",
        "possibleVals": [
            "string"
        ],
        "render":{  
          "inputHeading": "remoteOrderlink",
          "type": "textfield",
        } 
    },
    {
        "name": "remoteOrderlinkAdditionalMessage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Additional message related to remote order links.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "remoteOrderlinkAdditionalMessage",
          "type": "textfield",
        }
    },
    {
        "name": "recoEngineUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for a recommendation engine.",
        "possibleVals": [
            "string"
        ],
        "render":{  
          "inputHeading": "recoEngineUrl",
          "type": "textfield",
        } 
    },
    {
        "name": "callExternalApiForRecommendation",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Configuration to call external APIs for recommendations.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "callExternalApiForRecommendation",
          "type": "textfield",
        }
    },
    {
        "name": "recoEngineOutletsFileUrl",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "URL for a file containing outlets for recommendation engine.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "recoEngineOutletsFileUrl",
          "type": "textfield",
        }
    },
    {
        "name": "retailerRegistrationTkp",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "Registration TKP (Transaction Key Panel) for retailers.",
        "possibleVals": [
            "string"
        ] ,
        "render":{  
          "inputHeading": "retailerRegistrationTkp",
          "type": "textfield",
        }
    }
],        
      "domainType":"app_configuration",
      "heading": "App Configuration",
      "import": true,
      "subSections": [
          {
              "sectionHeading": "LOGO CONFIGURATION",
              "inputFields": [
                  {
                    "name": "clientLogo",
                  },
                  {
                    "name": "clientHeaderLogo",
                  },
                  {
                    "name": "appIcon",
                  },
                  {
                    "name": "shareLogoImage",
                  },
              ]
          },
          {
              "sectionHeading": "APP NAME CONFIGURATION",
              "inputFields": [
                  {
                      "name": "appName"
                  },
                  {
                    "name": "isAppOffline",
                  },
                  {
                    "name": "clientLogoHeight",
                  },
                  {
                    "name": "clientHeaderLogoHeight",
                  },
                  {
                      "name": "moengageKey"
                  },
                  {
                    "name": "faqCount",
                  },
              ]
          },
          {
              "sectionHeading": "HEADER BANNER",
              "inputFields": [
                  {
                    "name": "appBarBackgroundType",
                      "child": [
                          {
                            "name": "solidAppBarColor",
                          },
                          {
                            "name": "gradientAppBarColor",
                          },
                          {
                            "name": "appbarBackgroundImage",
                          }
                        ]
                  },
                  {
                      "name": "appBarColor"
                  },
              ]
          },
          {
              "sectionHeading": "LOGIN BANNER",
              "inputFields": [
                  {
                    "name": "loginBanner",
                  },
              ]
          },
          {
              "sectionHeading": "LOADING SCREEN CONFIGURATION",
              "inputFields": [
                  {
                      "name": "shareText"
                  },
                  {
                      "name": "psLink"
                  },
                  {
                      "name": "loadingScreenText"
                  },
                  {
                    "name": "loaderGIF",
                  },
                  // {
                  //     "inputHeading": "Upload the launch screen gif",
                  //     "type": "image",
                  //     "name": "loaderGIF",
                  //     "extendedAttributes":{
                  //         "label": "Upload Loader GIF",
                  //         "width":512,
                  //         "height":512                            
                  //     }
                  // },
                  {
                    "name": "loadingBackgroundImage",
                  },
              ]
          },
          {
              "sectionHeading": "OTHER CONFIGURATION",
              "inputFields": [
                  {
                      "name": "appPackageName"
                  },
                  {
                      "name": "privacyPolicyValidation"
                  },
                  {
                    "name": "isSuggestProductToBeShown",
                  },
                  {
                    "name": "slackAlertChannel",
                  },
                  {
                      "name": "validateCustomerType",
                  },
                  {
                    "name": "shipmentOptionsVisibility",
                  },
                  {
                      "name": "storeInRange"
                  },
                  {
                      "name": "enableDistanceBasedOutletSorting"
                  },
                  {
                      "name": "outOfRangePopUpVisible"
                  },
                  {
                      "name": "locationPopup"
                  },
                  {
                      "name": "loadingScreenTextList"
                  },
                  {
                      "name": "ondcWebviewServiceUrl"
                  },
                  {
                      "name": "ondcLoaderImage"
                  },
                  {
                      "name": "ondcLoaderGif"
                  },
                  {
                      "name": "ondcWebviewLaunchUrl"
                  },
                  {
                      "name": "ondcWebLaunchUrl"
                  },
                  {
                      "name": "kibanaConfig"
                  },
                  {
                      "name": "encryptImage"
                  },
                  {
                      "name": "showPromoTransaction"
                  },
                  {
                      "name": "minimizePromoRedemptionJourney"
                  },
                  {
                      "name": "addPromoOtpValidation"
                  },
                  {
                      "name": "externalAppDeepLink"
                  },
                  {
                      "name": "deepLinkUrl"
                  },
                  {
                      "name": "appStoreLink"
                  },
                  {
                      "name": "consumerPromoOutletsFileUrl"
                  },
                  {
                      "name": "tvAdsHeading"
                  },
                  {
                      "name": "tvAdsSubheading"
                  },
                  {
                      "name": "remoteOrderlinkMessage"
                  },
                  {
                      "name": "remoteOrderlink"
                  },
                  {
                      "name": "remoteOrderlinkAdditionalMessage"
                  },
                  {
                      "name": "recoEngineUrl"
                  },
                  {
                      "name": "callExternalApiForRecommendation"
                  },
                  {
                      "name": "recoEngineOutletsFileUrl"
                  },
                  {
                      "name": "retailerRegistrationTkp"
                  },

              ]
          },
      ]
  },
  "theme_configuration":{
    "configurations": [
      {
          "name": "themeColor",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "theme color",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Theme Color",
            "type": "colorInput",
          }
      },
      {
          "name": "themeDisabledButtonColor",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "theme color",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "themeDisabledButtonColor",
            "type": "colorInput",
          }
      }
  ],        
      "domainType":"theme_configuration",
      "heading": "Theme Configuration",
      "import": true,
      "subSections":[
          {
              "sectionHeading": "ENTER THE HEXCODE OF THE THEME COLOR",
              "inputFields": [
                  {
                      "name": "themeColor",
                  },
                  {
                    "name": "themeDisabledButtonColor",
                },
              ]
          }
      ]
  },
  "customer_configuration":{
    "configurations": [
      {
          "name": "currencySymbol",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "currency Symbol",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Select the currency symbol",
            "type": "textfield",
          }
      },
      {
          "name": "currency",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "currency Symbol",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Select the currency",
            "type": "textfield",
          }
      },
      {
          "name": "supportNumber",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "support number",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Enter support number",
            "type": "textfield",
          }
      },
      {
          "name": "privacyLink",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "privacylink",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "privacyLink",
            "type": "textfield",
          }
      },
      {
          "name": "tncLink",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "tncLink",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "tncLink",
            "type": "textfield"
          }
      },
      {
          "name": "numberFormat",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "This is the number format of the app",
          "possibleVals": ["en-US", "en-IN"],
          "render":{
            "inputHeading": "Select the format of the number",
            "type": "select",
            "extendedAttributes":{
               "lableId":"",
               "optionConfig":{
                "options":[
                    {
                        "value":"en-IN",
                        "title":"en-IN"
                    },
                    {
                        "value":"en-US",
                        "title":"en-US"
                    }
                ]
               }
            },
          }
      },
      {
          "name": "dialCode",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "This is the dial code of the country in which app is used",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Enter the dial code",
            "type": "textfield",
          }
      },
      {
          "name": "countryCode",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "The country code of the country in which app is being used",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Select the country code",
            "type": "select",
            "extendedAttributes":{
                "lableId":"",
                "optionConfig":{
                    "fetchOption":"true",
                    "fetchType": "country"
                }
            },
          }
      },
      {
          "name": "clientTimeZone",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "The time zone format of the app",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Select the time zone",
            "type": "select",
            "extendedAttributes":{
            "lableId":"",
            "optionConfig":{
              "fetchOption":"true",
              "fetchType": "timeZone"
            }
            },
          }
      },
      {
          "name": "customerServiceInfo",
          "type": "string",
          "value": "",
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "Information about customer service",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "customerServiceInfo",
            "type": "textfield",
          }
      },
      // {
      //     "name": "externalAppDeepLink",
      //     "type": "string",
      //     "value": "",
      //     "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      //     "description": "Deep link to an external application",
      //     "possibleVals": ["string"],
      //     "render":{}
      // }
  ],        
      "domainType":"customer_configuration",
      "heading": "Customer Configuration",
      "import": true,
      "subSections":[
          {
              "sectionHeading": "",
              "inputFields": [
                  {
                      "name": "countryCode",
                      "child": [
                          {
                            "name": "clientTimeZone",
                          },
                          {
                            "name": "dialCode"
                          }
                      ]
                  },
                  {
                      "name": "numberFormat",       
                  },
                  {
                      "name": "currency",
                  },
                  {
                      "name": "currencySymbol",
                  },
                  {
                      "name": "supportNumber",
                  },
                  {
                    "name": "privacyLink",
                },
                {
                  "name": "tncLink",
              },
              {
                "name": "customerServiceInfo",
            },
              ]
          }
      ]
  },
  "filters_label_configuration":{
    "configurations": [
      {
          "name": "pieceSizeLabelMapping",
          "type": "object",
          "value": {},
          "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
          "description": "custom disclaimers in order summary page",
          "possibleVals": ["string[]"],
          "render":{
            "inputHeading": "",
            "type": "labelInput",
          }
      }
  ],        
      "domainType":"filters_label_configuration",
      "heading": "Filter Label Configuration",
      "import": true,
      "subSections":[
          {
              "sectionHeading": "PACK SIZE LABEL",
              "inputFields": [
                  {
                      "name": "pieceSizeLabelMapping",
                  },
              ]
          }
      ]
  },
  "sfa_configurations":{
    "configurations": [
      {
          "name": "storeInRange",
          "type": "number",
          "value": 0,
          "docUrl": "",
          "description": "Outlet Range",
          "possibleVals": [],
          "render":{
            "inputHeading": "Enter the store in range.",
            "type": "textfield",
            "extendedAttributes": {
              "textType": "number"
          }
          }
      },
      {
          "name": "loaderFailedText",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "load failure text",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Enter the loader failure text.",
            "type": "textfield"
          }
      },
      {
          "name": "pjpLabel",
          "type": "string",
          "value": "PJP",
          "docUrl": "",
          "description": "PJP label in outlet screen",
          "possibleVals": ["PJP", "CPG"],
          "render":{
            "inputHeading": "Enter the pjp label text",
                      "type": "select",
                      "extendedAttributes": {
                          "lableId": "",
                          "optionConfig": {
                              "options": [
                                  {
                                      "value": "PJP",
                                      "title": "PJP"
                                  },
                                  {
                                      "value": "CPG",
                                      "title": "CPG"
                                  }
                              ]
                          }
                      }
          }
      },
      {
          "name": "additionalMessage",
          "type": "string",
          "value": "",
          "docUrl": "",
          "description": "additionalMessage",
          "possibleVals": ["string"],
          "render":{
            "inputHeading": "Select the additional message",
            "type": "textfield"
          }
      },
      {
          "name": "forceUpdateConfig",
          "type": "list",
          "value": [
              {
                  "showForceUpdate": false,
                  "latestIosVersion": "1.0.0",
                  "latestAndroidVersion": "1.0.0"
              }
          ],
          "docUrl": "",
          "description": "Configuration to show force update screen as soon as the user opens the app.",
          "possibleVals": [],
          "render":{
            "inputHeading": "Show configuration to force update on screen as soon as the user opens the app (select to enable)",
            "type": "checkbox",
            "extendedAttributes": {
                "label": "Enable Force Update"
            },
          }
      }
  ],        
      "domainType":"sfa_configurations",
      "heading": "SFA Configuration",
      "import": true,
      "subSections":[
          {
              "sectionHeading": "",
              "inputFields": [
                  {
                    "name": "storeInRange"
                  },
                  {
                    "name": "loaderFailedText"
                  },
                  {
                    "name": "pjpLabel"
                  },
                  {
                    "name": "additionalMessage"
                  },
                  {
                    "name": "forceUpdateConfig",
                    "child": [
                      {
                        "inputHeading": "Android app version",
                        "type": "textfield",
                        "name": "forceUpdateConfig.latestIosVersion",
                      },
                      {
                          "inputHeading": "Ios app version",
                          "type": "textfield",
                          "name": "forceUpdateConfig.latestAndroidVersion"
                        }
                  ]
                  },
              ]
          }
      ]
  },
};

const ConfigComponents = (props: { showBackButton?: boolean,configName?:any }) => {
    const [cardValidationsSchema, setCardValidationSchema] = useState({});
    const [cardConfig, setCardConfig] = useState<any[]>([]);
    const convertData = (data:any) => {
      const updateInputFields = (inputFields:any, configurationsMap:any) => {
        inputFields.forEach((inputField:any) => {
          const config = configurationsMap[inputField.name];
          if (config && config.render) {
            Object.assign(inputField, config.render);
            delete config.render; 
          }
          if (inputField.child) {
            updateInputFields(inputField.child, configurationsMap);
          }
        });
      };
      Object.keys(data).forEach(configKey => {
        const configSection = data[configKey];
        const configurationsMap = configSection.configurations.reduce((map:any, config:any) => {
          map[config.name] = config;
          return map;
        }, {});
    
        configSection.subSections.forEach((subSection:any) => {
          updateInputFields(subSection.inputFields, configurationsMap);
        });
      });
    
      return data;
    };

const LOCAL_STORAGE_KEY = 'configData';

const getConfigDataFromLocalStorage = () => {
    const storedData = localStorage.getItem(LOCAL_STORAGE_KEY);
    return storedData ? JSON.parse(storedData) : null;
};

    const [configDataLocal, setConfigDataLocal] = useState(() => {
      const initialConfigData = getConfigDataFromLocalStorage() || configData2;
      return initialConfigData;
  });
    const configData = convertData(configDataLocal);
    console.log("configData",configData)
    const [values, setValues] = useState(() => ({
      ...configData,
      ...configData[props.configName]?.configurations.reduce((acc:any, config:any) => {
        acc[config.name] = config;
        return acc;
      }, {})
    }));
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");


    const [showConfigPopup, setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{ [key: string]: any[] }>({});
    const newConfigRef = useRef<{ [key: string]: any[] }>({});

    const [importConfigState, setImportConfigState] = useState(false);
    
    
    const getConfiguration = async () => {
        try {
            const resp = await getNewConfiguration(configData[props.configName].domainType);
            const config_data: any[] = resp?.domainValues;
            curConfigRef.current[configData[props.configName].domainType] = config_data;
            setCardConfig([...config_data])
        } catch (err) {
            Sentry.captureException(err);
        }
    }
    const setConfiguration = async () => {
        try {
            if (cardConfig.length) {
                const result = { ...values } 
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                cardConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr
                })
                setValues({ ...result });
                setCardValidationSchema({ ...resValidations })
            }
        } catch (err) {
            Sentry.captureException(err);
        }
    }
    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            [props.configName]:"importAll"
        })
        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
        setShowConfigPopup(true);
    }
    const onConfigComparatorSuccess = async () => {
        await doFinalConfigSubmit(configData[props.configName]?.domainType, newConfigRef.current[configData[props.configName]?.domainType], curConfigRef);
        getConfiguration();
    }
    const saveConfiguration = async (preview?: boolean) => {
        try {
            const resultantValues:any = { ...values};
            const cardSchema = yup.object({ ...cardValidationsSchema })
            const validationObject:any = {};
            Object.keys(resultantValues).forEach(key=>{
                validationObject[key] = resultantValues[key].value;
            })
            await cardSchema.validate(validationObject)
            const convertedVals = convertValuesToConfig(resultantValues, cardConfig);
            newConfigRef.current[configData[props.configName]?.domainType] = convertedVals;
            setShowConfigPopup(true);

        } catch (err) {
            Sentry.captureException(err);
            console.log("err===", err)
            if (err instanceof Error)
                openPopup( 'Error',"Validation Error occured : " + err?.message)
        }
    }

    useEffect(() => {
      setValues(deepClone(
        configData[props.configName]?.configurations.reduce((acc: { [x: string]: any; }, config: { name: string | number; }) => {
          acc[config.name] = config;
          return acc;
        }, {})
      ));
        getConfiguration();
    }, [props.configName])

    useEffect(() => {
        setConfiguration();
    }, [cardConfig,props.configName])
    return (
        <div className="auth_config_container">
            {configData[props.configName]?.import && <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={[props.configName]} importConfigCallback={importConfiguration} />}
            <ConfigurationHeader  importConfiguration={configData[props.configName]?.import ? () => { setImportConfigState(true) } : undefined} heading={configData[props.configName]?.heading} showBackButton={props.showBackButton} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">
                {configData[props.configName]?.subSections && configData[props.configName]?.subSections.map((subsection: any, index: number) => {
                    return (
                        <>
                            {subsection?.sectionHeading && <div className="form_header" key={index}>
                                <BorderHeading>{subsection.sectionHeading}</BorderHeading>
                            </div>}

                            {subsection?.inputFields && subsection?.inputFields.map((inputField: any, inputIndex: number) => (
                                <div key={inputIndex}>
                                    <GenericUIComponent
                                        indent={1}
                                        values={values}
                                        setValues={setValues}
                                        heading={inputField?.inputHeading}
                                        type={inputField?.type}
                                        name={inputField?.name}
                                        extendedAttributes={inputField?.extendedAttributes}
                                    />
                                     {inputField?.child && values[inputField.name]?.value && inputField.child.map((childInputField: any, childIndex: number) => {
                                        if(childInputField?.extendedAttributes?.parentName){
                                            if (values[inputField.name]?.value === childInputField?.extendedAttributes?.parentName) {
                                                return (
                                                    <div key={childIndex}>
                                                        <GenericUIComponent
                                                            indent={2}
                                                            values={values}
                                                            setValues={setValues}
                                                            heading={childInputField?.inputHeading}
                                                            type={childInputField?.type}
                                                            name={childInputField?.name}
                                                            extendedAttributes={childInputField?.extendedAttributes}
                                                        />
                                                    </div>
                                                );
                                            }
                                            return null;
                                        }else{
                                            return (
                                                <div key={childIndex}>
                                                    <GenericUIComponent
                                                        indent={2}
                                                        values={values}
                                                        setValues={setValues}
                                                        heading={childInputField?.inputHeading}
                                                        type={childInputField?.type}
                                                        name={childInputField?.name}
                                                        extendedAttributes={childInputField?.extendedAttributes}
                                                    />
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            ))}
                        </>
                    );
                })}
            </div>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={setOpenGenericModal} />

            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>
    )
}

export default ConfigComponents